import React from "react";
import ReactMarkdown from "react-markdown";
import "katex/dist/katex.min.css";
import { InlineMath, BlockMath } from "react-katex";
import rehypeRaw from "rehype-raw";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

const UserMessage = ({ message }) => {
  let content = '';

  try {
    if (message?.content === null || message?.content === undefined) {
      content = '';
    } else if (typeof message.content === 'object') {
      content = JSON.stringify(message.content);
    } else {
      content = String(message.content);
    }
  } catch (error) {
    console.error('Error processing message content:', error);
    content = '';
  }

  return (
    <div className="bg-blue-100 p-4 rounded-lg shadow">
      <div className="prose max-w-none">
        <ReactMarkdown
          remarkPlugins={[remarkMath]}
          rehypePlugins={[rehypeKatex, rehypeRaw]}
          components={{
            inlineMath: ({ node, ...props }) => {
              try {
                console.log('UserMessage InlineMath props:', props);
                return <InlineMath math={String(props.value || '')} />;
              } catch (error) {
                console.error('Error in InlineMath:', error);
                return <span>{props.value || ''}</span>;
              }
            },
            math: ({ node, ...props }) => {
              try {
                console.log('UserMessage BlockMath props:', props);
                return <BlockMath math={String(props.value || '')} />;
              } catch (error) {
                console.error('Error in BlockMath:', error);
                return <div>{props.value || ''}</div>;
              }
            }
          }}
        >
          {content}
        </ReactMarkdown>
      </div>
      {message.image_url && (
        <div className="mt-2">
          <img
            src={message.image_url}
            alt="User uploaded"
            className="max-w-full rounded"
          />
        </div>
      )}
    </div>
  );
};

export default UserMessage;